import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCargoTags(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_TAGS,
		ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAGS,
		options
	)
}

function _getCargoTag(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_TAGS,
		ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAG,
		options
	)
}

function _createCargoTag(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_TAGS,
		ModulesConfigMap[ModulesMap.CARGO_TAGS].CREATE_CARGO_TAG,
		options
	)
}

function _putCargoTag(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_TAGS,
		ModulesConfigMap[ModulesMap.CARGO_TAGS].PUT_CARGO_TAG,
		options
	)
}

function _patchCargoTag(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_TAGS,
		ModulesConfigMap[ModulesMap.CARGO_TAGS].PATCH_CARGO_TAG,
		options
	)
}

function _deleteCargoTag(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_TAGS,
		ModulesConfigMap[ModulesMap.CARGO_TAGS].DELETE_CARGO_TAG,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAGS]: _getCargoTags,

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAG]: _getCargoTag,

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].CREATE_CARGO_TAG]: _createCargoTag,
	[ModulesConfigMap[ModulesMap.CARGO_TAGS].PUT_CARGO_TAG]: _putCargoTag,
	[ModulesConfigMap[ModulesMap.CARGO_TAGS].PATCH_CARGO_TAG]: _patchCargoTag,
	[ModulesConfigMap[ModulesMap.CARGO_TAGS].DELETE_CARGO_TAG]: _deleteCargoTag,
}